import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
  POs: [],
  purchaseOrderTemplateId: 1,
  selectAllField: false,
  selectedPOs: [],
  totalPOs: 0,
  selectedSupplier: null,
  POForDeliveryNotes: null,
  POForInvoices: null
}

export default {
  namespaced: true,

  state: initialState,

  getters: getters,

  actions: actions,

  mutations: mutations
}
